import { createClaimRequest } from './helper';
export const getClaimById = createClaimRequest({
    route: '/claim/claimData/:claimNumber',
    method: 'get',
    source: 'data',
});
